"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetUserManager = void 0;
const react_query_1 = require("react-query");
const UserProfile_1 = require("client/UserProfile");
const userManagerKeys_1 = __importDefault(require("src/consts/queryKeys/userManagerKeys"));
const useGetUserManager = (placementId, options) => {
    const fetchManager = () => {
        return (0, UserProfile_1.getManagerV2)(placementId);
    };
    return (0, react_query_1.useQuery)(userManagerKeys_1.default.userManager(placementId), () => fetchManager(), { ...options, cacheTime: Infinity, staleTime: 1000 * 360 });
};
exports.useGetUserManager = useGetUserManager;
